import {Injectable, inject, signal} from '@angular/core';
import {AuthService} from './auth.service';
import {User} from '../model/user/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private readonly authService = inject(AuthService);

  private readonly _userProfileState = signal<User | undefined>(undefined);
  readonly currentUserProfile = this._userProfileState.asReadonly();

  async fetchAndUpdateUserProfile(): Promise<void> {
    const freshUserProfile = await this.authService.getUserProfile();
    this._userProfileState.set(freshUserProfile);
  }

  async loadUserProfileOnAppStart(): Promise<void> {
    await this.fetchAndUpdateUserProfile();
  }

  resetUserProfileOnLogout(): void {
    this._userProfileState.set(undefined);
  }
}
